import * as React from 'react';
import { NavLink, useNavigate, } from "react-router-dom-v5-compat";

import { DropdownInput, SMALL_ICON_BASE_SRC, } from '../../../../Shared/index'
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility'

const barGraphIncreasingIconSrc = `${SMALL_ICON_BASE_SRC}/bar-graph-increasing.svg`
const groupIconSrc = `${SMALL_ICON_BASE_SRC}/group.svg`
const accountIconSrc = `${SMALL_ICON_BASE_SRC}/account.svg`
const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`

const Sidebar = ({
  classrooms,
  closeMobileSidebar,
  showMobileSidebar,
  showSidebarButton,
  selectedClassroomId,
  setSelectedClassroom
}) => {
  const navigate = useNavigate();

  const { modalRef } = useModalAccessibility(closeMobileSidebar);

  React.useEffect(() => {
    if (!selectedClassroomId) { return }

    const updatedPath = location.pathname.replace(
      /\/classroom\/\d+/,
      `/classroom/${selectedClassroomId}`
    );

    navigate(updatedPath);
  }, [selectedClassroomId])

  const classroomOptions = classrooms.map(classroom => ({ ...classroom, value: classroom.id, label: classroom.name, }))

  const baseLink = `/teachers/progress_reports/diagnostic_insights/classroom/${selectedClassroomId}`

  const activeClassName = ({ isActive }) => (isActive ? 'active focus-on-light' : 'focus-on-light');

  const attributesForMobile = showMobileSidebar ? {
    'aria-label': 'Diagnostic Insights Navigation',
    'aria-modal': true,
    ref: modalRef,
    role: 'dialog',
    tabIndex: -1
  } : {}

  return (
    <aside className={`sidebar-container ${showMobileSidebar ? 'mobile-open' : 'mobile-hidden'}`} data-testid="sidebar" {...attributesForMobile}>
      <div className="top-section">
        <button aria-expanded={true} className="interactive-wrapper focus-on-light" onClick={closeMobileSidebar} type="button">
          <img alt="" src={closeIconSrc} />
          Close
        </button>
      </div>
      <div className="sidebar">
        <div className="sidebar-section show-sidebar-button-wrapper">
          {showSidebarButton}
        </div>
        <div className="sidebar-section">
          <DropdownInput
            className="bordered small"
            disabled={!classroomOptions.length}
            handleChange={setSelectedClassroom}
            isSearchable={false}
            label="Class"
            options={classroomOptions}
            placeholder="No Classrooms"
            value={classroomOptions.find(opt => opt.value === selectedClassroomId)}
          />
        </div>
        <div className="sidebar-section">
          <nav aria-labelledby="historyAndRecommendationsTitle">
            <h2 id="historyAndRecommendationsTitle">History & Recommendations</h2>
            <NavLink className={activeClassName} to={`${baseLink}/history_and_recommendations/by_class`}><img alt="" src={groupIconSrc} />By Class</NavLink>
            <NavLink className={activeClassName} to={`${baseLink}/history_and_recommendations/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
          </nav>
        </div>
        <div className="sidebar-section">
          <nav aria-labelledby="performanceInsightsTitle">
            <h2 id="performanceInsightsTitle">Performance Insights</h2>
            <NavLink className={activeClassName} to={`${baseLink}/performance_insights/by_skill`}><img alt="" src={barGraphIncreasingIconSrc} />By Skill</NavLink>
            <NavLink className={activeClassName} to={`${baseLink}/performance_insights/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
          </nav>
        </div>
        <div className="sidebar-section">
          <nav aria-labelledby="practiceInsightsTitle">
            <h2 id="practiceInsightsTitle">Practice Insights</h2>
            <NavLink className={activeClassName} to={`${baseLink}/practice_insights/by_skill`}><img alt="" src={barGraphIncreasingIconSrc} />By Skill</NavLink>
            <NavLink className={activeClassName} to={`${baseLink}/practice_insights/by_student`}><img alt="" src={accountIconSrc} />By Student</NavLink>
          </nav>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar
